export const homePage = {
  hero: {
    tag: "手作餅皮｜厚實內餡｜現烤香氣｜冷凍宅配｜加盟合作",
    title: "一口咬下剛剛好的甜，來加綉綉紅豆餅",
    subtitle:
      "從餅皮香氣、手作內餡，到每一口剛出爐的溫度，來加綉綉希望把台灣人熟悉的紅豆餅，做成日常裡最安心、最療癒的一份小點心。",
    ctaPrimary: "查看人氣口味",
    ctaSecondary: "了解加盟方案",
  },
  tagline: {
    title: "把傳統紅豆餅，做成每天都想再來一顆的溫暖點心",
    body: "紅豆餅不是只要熱就好吃，而是餅皮厚薄、火候節奏、內餡比例與出餐時間都要剛剛好。來加綉綉紅豆餅希望保留傳統點心的親切感，也把產品穩定度、口味記憶點與品牌體驗一起做好。",
  },
  highlights: {
    cards: [
      {
        title: "剛出爐的香氣，是最好的招牌",
        desc: "讓顧客還沒走近，就先聞到餅皮與內餡交疊的甜點香氣。",
      },
      {
        title: "每一口都吃得到飽滿",
        desc: "從經典紅豆到創意口味，重視內餡比例與口感層次。",
      },
      {
        title: "不是只賣點心，而是賣一份日常期待",
        desc: "讓紅豆餅成為上班、放學、散步、市集與家庭分享時的小幸福。",
      },
    ],
  },
  popularFlavors: {
    title: "人氣紅豆餅口味",
    subtitle: "",
    flavors: [
      {
        name: "經典紅豆",
        desc: "綿密紅豆香氣，保留最熟悉的台灣甜點記憶。",
      },
      {
        name: "奶油卡士達",
        desc: "滑順奶香與現烤餅皮，是大人小孩都喜歡的經典款。",
      },
      {
        name: "芋泥香香",
        desc: "濃郁芋香與細緻口感，適合喜歡厚實甜點的人。",
      },
      {
        name: "花生芝麻",
        desc: "堅果香氣濃厚，越嚼越有層次。",
      },
      {
        name: "起司鹹香",
        desc: "鹹甜交錯，適合想換口味的顧客。",
      },
      {
        name: "季節限定",
        desc: "依季節推出限定風味，讓每次回訪都有新期待。",
      },
    ],
    cta: "查看產品介紹",
  },
  delivery: {
    title: "把來加綉綉的香氣，帶回家慢慢享用",
    desc: "除了現場現烤，來加綉綉也規劃冷凍宅配與禮盒服務，讓顧客能在家中、辦公室、聚會或節慶送禮時，也能享受紅豆餅的溫暖滋味。",
    ctaPrimary: "了解冷凍宅配",
    ctaSecondary: "訂購禮盒",
  },
  franchise: {
    title: "想把紅豆餅做成一份事業？從來加綉綉開始",
    desc: "紅豆餅看似簡單，真正要穩定經營，需要產品、出餐、成本、地點、行銷與熟客經營一起規劃。來加綉綉希望協助想副業、擺攤、市集、店面或品牌創業的人，縮短摸索時間，建立能持續經營的小生意。",
    bullets: ["品牌系統", "產品與口味配置", "開店與營運陪跑"],
    cta: "了解加盟專區",
  },
  news: {
    title: "最新消息",
    viewAll: "查看全部",
    articles: [
      {
        tag: "新口味上市",
        title: "季節限定紅豆餅",
        date: "2026.05.01",
        summary:
          "來加綉綉推出夏季限定口味，以當季水果入餡，清爽不膩，歡迎到店品嚐。",
      },
      {
        tag: "冷凍宅配",
        title: "冷凍宅配開放預購",
        date: "2026.04.15",
        summary:
          "全台冷凍宅配正式上線，禮盒與散裝皆可預購，低溫保鮮送到府。",
      },
      {
        tag: "加盟說明會",
        title: "加盟說明會報名中",
        date: "2026.04.01",
        summary:
          "五月加盟說明會開放報名，完整產品教學、成本分析與營運規劃一次掌握。",
      },
    ],
  },
  bottomCta: {
    title: "想訂購、合作或了解加盟？",
    desc: "歡迎加入 LINE 或填寫表單，讓我們依你的需求提供產品、禮盒或加盟合作資訊。",
    ctaPrimary: "加入 LINE 詢問",
    ctaSecondary: "填寫聯絡表單",
  },
};

export const navItems = [
  { label: "首頁", path: "/" },
  { label: "品牌故事", path: "/brand-story" },
  { label: "產品介紹", path: "/products" },
  { label: "最新消息", path: "/news" },
  { label: "職人日誌", path: "/craft-diary" },
  { label: "電商/禮盒", path: "/gift-box" },
  { label: "加盟專區", path: "/franchise" },
  { label: "聯絡我們", path: "/contact" },
];